import { ReactNode } from "react";
import { cn } from "@/lib/utils";

// Shared property rows of detail pages (PRD / bug / channel / engagement sheet).

/** Bordered container for a stack of <Property> rows. */
export const PropertyList = ({
  children,
  className,
}: {
  children: ReactNode;
  className?: string;
}) => (
  <div className={cn("divide-y rounded-lg border px-3", className)}>
    {children}
  </div>
);

/** One labeled row of the properties panel (grid, multiline-friendly). */
export const Property = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="grid grid-cols-[80px_1fr] items-start gap-2 py-3 text-sm">
    <span className="pt-0.5 text-muted-foreground">{label}</span>
    <div className="min-w-0">{children}</div>
  </div>
);

/** Compact single-line variant (sheet panels): label + inline content. */
export const PropertyRow = ({
  label,
  children,
}: {
  label: string;
  children: ReactNode;
}) => (
  <div className="flex items-center gap-3">
    <span className="w-20 shrink-0 text-sm text-muted-foreground">{label}</span>
    <div className="flex min-w-0 flex-1 items-center gap-2 text-sm">
      {children}
    </div>
  </div>
);
